import axios from "axios";

export const postFetcher = async (url: string, data: any, config?: any) => {
  try {
    return await axios.post(url, data, {
      params: config,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  } catch (err) {
    throw err;
  }
};

export const getFetcher = async (url: string, config?: any) => {
  try {
    return await axios.get(url, {
      params: config,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  } catch (err) {
    throw err;
  }
};

export const putFetcher = async (url: string, data: any, config?: any) => {
  try {
    return await axios.put(url, data, {
      params: config,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  } catch (err) {
    throw err;
  }
};

export const deleteFetcher = async (url: string, config?: any) => {
  try {
    return await axios.delete(url, {
      params: config,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  } catch (err) {
    throw err;
  }
};
